export function lazyScript() {
  const targets = document.querySelectorAll('[data-lazy-script]');
  const options = {
    root: null,
    rootMargin: '0px 0px 100px 0px',
  };

  function fn(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry) => {
      const {target, intersectionRatio} = entry;

      if (intersectionRatio > 0) {
        replaceNodeWithScript(target as HTMLElement);
        io.unobserve(target);
      }
    });
  }

  const io = new IntersectionObserver(fn, options);
  targets.forEach((node) => io.observe(node));
}

function replaceNodeWithScript(node: HTMLElement) {
  const src = node.dataset.src;
  const script = document.createElement('script');

  if (!src) {
    return;
  }

  script.src = src;

  node.replaceWith(script);
}
